import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './AddMorePlaceholder.module.scss';

type Props = {
	onClick: () => void;
};

const AddMorePlaceholder = ({ onClick }: Props) => {
	const { t } = useTranslation();

	return (
		<div className={styles.container} onClick={onClick}>
			<div className={styles.icon}>+</div>
			<div className={styles.label}>{t('dashboard.drawer.add_widget')}</div>
		</div>
	);
};

export default AddMorePlaceholder;
